import {
  ICreatePayoutAccountPayload,
  IUpdatePayoutAccountLabelPayload
} from '@pharvio/core/shared';

export class LoadPayoutAccounts {
  static readonly type = '[PayoutAccounts] Load Accounts';
}

export class LoadBanks {
  static readonly type = '[PayoutAccounts] Load Banks';
}

export class ResolveBankAccount {
  static readonly type = '[PayoutAccounts] Resolve Bank Account';
  constructor(
    public readonly bankCode: string,
    public readonly accountNumber: string
  ) {}
}

export class ClearResolveResult {
  static readonly type = '[PayoutAccounts] Clear Resolve Result';
}

export class CreatePayoutAccount {
  static readonly type = '[PayoutAccounts] Create Account';
  constructor(public readonly payload: ICreatePayoutAccountPayload) {}
}

export class ArchivePayoutAccount {
  static readonly type = '[PayoutAccounts] Archive Account';
  constructor(public readonly id: string) {}
}

export class UpdatePayoutAccountLabel {
  static readonly type = '[PayoutAccounts] Update Account Label';
  constructor(
    public readonly id: string,
    public readonly payload: IUpdatePayoutAccountLabelPayload
  ) {}
}

export class SelectPayoutAccount {
  static readonly type = '[PayoutAccounts] Select Account';
  constructor(public readonly id: string | null) {}
}
